import {Pipe, PipeTransform} from "@angular/core";
import {StripeDisabledReasons} from "../consts/StripeDisabledReasons";

@Pipe({
  name: 'stripeDisabledReason'
})
export class StripeDisabledReasonPipe implements PipeTransform {
  public transform(reasonCode: string): string {

    let reason = StripeDisabledReasons.find((reasonP) =>
      reasonP.code.toLowerCase() === reasonCode.toLowerCase()
    );

    if (!reason) {
      return "Unknown reason";
    }

    return reason.reason;
  }
}
